<template>
    <div class="column" v-if="dev"><slot></slot></div>
    <!--<Dev>some</Dev>-->
</template>
<script>
export default {data: function () {return {}}}
</script>



















